var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFullscreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.230469 0.869995V5.43994H1.54047V1.52002H5.46045V0.209961H0.890442C0.520442 0.219961 0.230469 0.509995 0.230469 0.869995Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.57 0.219971H11V1.53003H14.92V5.44995H16.23V0.880005C16.23 0.510005 15.93 0.219971 15.57 0.219971Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.92 13.7699H11V15.0798H15.57C15.93 15.0798 16.22 14.7899 16.22 14.4299V9.85986H14.91V13.7699H14.92Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.53021 9.8501H0.220215V14.4202C0.220215 14.7802 0.510239 15.0701 0.870239 15.0701H5.44019V13.7601H1.5202V9.8501H1.53021Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullscreen);
export default __webpack_public_path__ + "static/media/fullscreen.f7ff63e06c08d498e5994c05de104802.svg";
export { ForwardRef as ReactComponent };